import OrderItemModel from "@/models/OrderItemModel";

export default class OrderItemViewModel extends OrderItemModel {
	constructor(data?: any) {
        super(data);
		if (data) {
            this.vmId = data.vmId ?? 0;
            this.isItemValid = data.isItemValid ?? false;
			this.isItemPriceValid = data.isItemPriceValid ?? false;
		}
	}

    vmId = 0;
    isItemValid = false;
    isItemPriceValid = false;
}